// extracted by mini-css-extract-plugin
module.exports = {"message_banner":"MessageBanner_message_banner__1zFBu"};